import { render, staticRenderFns } from "./SkinInquiryDetail.vue?vue&type=template&id=1e3c7016&scoped=true"
import script from "./SkinInquiryDetail.vue?vue&type=script&lang=js"
export * from "./SkinInquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./SkinInquiryDetail.vue?vue&type=style&index=0&id=1e3c7016&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c7016",
  null
  
)

export default component.exports